import Badge from '../../elements/badge';
import React from 'react';
import { path } from '@uswitch/ev-utils/obj';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { Fragment as _Fragment } from "theme-ui/jsx-runtime";
export var Badges = function Badges(product) {
  var isPromoted = path(['comparables', 'promoted', 'value'], product);
  var isExclusive = path(['comparables', 'exclusive', 'value'], product);
  var promotedBadge = isPromoted ? _jsx(Badge, {
    children: 'Promoted'
  }, '') : _jsx(_Fragment, {});
  var exclusiveBadge = isExclusive ? _jsx(Badge, {
    children: 'Exclusive'
  }, '') : _jsx(_Fragment, {});
  return [promotedBadge, exclusiveBadge];
};
export default Badges;
//# sourceMappingURL=badges.js.map